var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryEmptyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 5H25C26.5 5 27.5 6 27.5 7.5V25C27.5 26.5 26.5 27.5 25 27.5H7.5C6 27.5 5 26.5 5 25V7.5C5 6 6 5 7.5 5ZM10 22.5H22.5V10H10V22.5ZM52.5 5H35C33.5 5 32.5 6 32.5 7.5V25C32.5 26.5 33.5 27.5 35 27.5H52.5C54 27.5 55 26.5 55 25V7.5C55 6 54 5 52.5 5ZM37.5 22.5H50V10H37.5V22.5ZM52.5 32.5H35C33.5 32.5 32.5 33.5 32.5 35V52.5C32.5 54 33.5 55 35 55H52.5C54 55 55 54 55 52.5V35C55 33.5 54 32.5 52.5 32.5ZM37.5 50H50V37.5H37.5V50ZM25 32.5H7.5C6 32.5 5 33.5 5 35V52.5C5 54 6 55 7.5 55H25C26.5 55 27.5 54 27.5 52.5V35C27.5 33.5 26.5 32.5 25 32.5ZM10 50H22.5V37.5H10V50Z",
    fill: "#D8DFE5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8894_59715",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 50,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 5H25C26.5 5 27.5 6 27.5 7.5V25C27.5 26.5 26.5 27.5 25 27.5H7.5C6 27.5 5 26.5 5 25V7.5C5 6 6 5 7.5 5ZM10 22.5H22.5V10H10V22.5ZM52.5 5H35C33.5 5 32.5 6 32.5 7.5V25C32.5 26.5 33.5 27.5 35 27.5H52.5C54 27.5 55 26.5 55 25V7.5C55 6 54 5 52.5 5ZM37.5 22.5H50V10H37.5V22.5ZM52.5 32.5H35C33.5 32.5 32.5 33.5 32.5 35V52.5C32.5 54 33.5 55 35 55H52.5C54 55 55 54 55 52.5V35C55 33.5 54 32.5 52.5 32.5ZM37.5 50H50V37.5H37.5V50ZM25 32.5H7.5C6 32.5 5 33.5 5 35V52.5C5 54 6 55 7.5 55H25C26.5 55 27.5 54 27.5 52.5V35C27.5 33.5 26.5 32.5 25 32.5ZM10 50H22.5V37.5H10V50Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8894_59715)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H60V60H0V0Z",
    fill: "#D8DFE5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryEmptyIcon);
export default __webpack_public_path__ + "static/media/CategoryEmptyIcon.da58dad0e642b69548c285b65663b1be.svg";
export { ForwardRef as ReactComponent };